import React from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import {makeStyles} from "@material-ui/core/styles";
import {Link} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
        cursor: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'  width='40' height='48' viewport='0 0 100 100' style='fill:black;font-size:24px;'><text y='50%'>🐱</text></svg>") 16 0,auto; `
    },
    cursor:{
        cursor: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'  width='40' height='48' viewport='0 0 100 100' style='fill:black;font-size:24px;'><text y='50%'>🐶</text></svg>") 16 0,auto; `
    }
}));

export default function MenuList() {
    const classes = useStyles();

    const [familias, setFamilias] = React.useState(false);
    const [artigos, setArtigos] = React.useState(false);
    const [clientes, setClientes] = React.useState(false);
    const [paciente, setPaciente] = React.useState(false);
    const [documentos, setDocumentos] = React.useState(false);
    const [compras, setCompras] = React.useState(false);

    const handleClickFamilias=()=>{
        setFamilias(!familias);
    }

    const handleClickArtigos=()=>{
        setArtigos(!artigos);
    }

    const handleClickClientes=()=>{
        setClientes(!clientes);
    }

    const handleClickDocumentos=()=>{
        setDocumentos(!documentos);
    }

    const handleClickPaciente=()=>{
        setPaciente(!paciente);
    }

    const handleClickCompras=()=>{
        setCompras(!compras);
    }

    return(
        <>
            <List>
                <Link to={"/dashboard"}>
                    <ListItem button className={classes.cursor}>
                        <ListItemText primary="Dashboard" />
                    </ListItem>
                </Link>
                <Divider />
                <List>
                    <ListItem button onClick={handleClickDocumentos} className={classes.cursor}>
                        <ListItemText primary="Encomendas" />
                    </ListItem>
                    <Collapse in={documentos} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link to={"/documentos"}>
                                <ListItem button className={classes.nested}>
                                    <ListItemText primary="Criar encomenda" />
                                </ListItem>
                            </Link>
                        </List>
                        <List component="div" disablePadding>
                            <Link to={"/documentos/lista/pagos"}>
                                <ListItem button className={classes.nested}>
                                    <ListItemText primary="Listar encomendas pagas" />
                                </ListItem>
                            </Link>
                        </List>
                        <List component="div" disablePadding>
                            <Link to={"/documentos/lista/pendente"}>
                                <ListItem button className={classes.nested}>
                                    <ListItemText primary="Listar encomendas por pagar" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>
                </List>
                <Divider />
                <List>
                    <ListItem button onClick={handleClickCompras} className={classes.cursor}>
                        <ListItemText primary="Compras" />
                    </ListItem>
                    <Collapse in={compras} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link to={"/compras"}>
                                <ListItem button className={classes.nested}>
                                    <ListItemText primary="Registar compra" />
                                </ListItem>
                            </Link>
                        </List>
                        <List component="div" disablePadding>
                            <Link to={"/compras/listar/pagas"}>
                                <ListItem button className={classes.nested}>
                                    <ListItemText primary="Listar compras pagas" />
                                </ListItem>
                            </Link>
                        </List>
                        <List component="div" disablePadding>
                            <Link to={"/compras/listar/pendentes"}>
                                <ListItem button className={classes.nested}>
                                    <ListItemText primary="Listar compras por liquidar" />
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>
                </List>
                <Divider />
                <Link to={"/pagamentos"}>
                    <ListItem button className={classes.cursor}>
                        <ListItemText primary="Pagamentos" />
                    </ListItem>
                </Link>
                <Divider />
                <ListItem button onClick={handleClickClientes} className={classes.cursor}>
                    <ListItemText primary="Clientes" />
                </ListItem>
                <Collapse in={clientes} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to={"/clientes/criar"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Criar cliente" />
                            </ListItem>
                        </Link>
                    </List>
                    <List component="div" disablePadding>
                        <Link to={"/clientes"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Listar clientes" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Divider />
                <ListItem button onClick={handleClickPaciente} className={classes.cursor}>
                    <ListItemText primary="Pacientes" />
                </ListItem>
                <Collapse in={paciente} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to={"/paciente/criar"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Criar paciente" />
                            </ListItem>
                        </Link>
                    </List>
                    <List component="div" disablePadding>
                        <Link to={"/paciente"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Listar Pacientes" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Divider />
                <ListItem button onClick={handleClickFamilias} className={classes.cursor}>
                    <ListItemText primary="Familias" />
                </ListItem>
                <Collapse in={familias} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to={"/familias/criar"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Criar familia" />
                            </ListItem>
                        </Link>
                    </List>
                    <List component="div" disablePadding>
                        <Link to={"/familias"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Listar familias" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
            </List>
            <Divider />
            <List>
                <ListItem button onClick={handleClickArtigos} className={classes.cursor}>
                    <ListItemText primary="Artigos" />
                </ListItem>
                <Collapse in={artigos} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to={"/artigos/criar"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Criar artigos" />
                            </ListItem>
                        </Link>
                    </List>
                    <List component="div" disablePadding>
                        <Link to={"/artigos"}>
                            <ListItem button className={classes.nested}>
                                <ListItemText primary="Listar artigos" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
            </List>
            <Divider />
            <Link to={"/utilizadores"} >
                <ListItem button className={classes.cursor}>
                    <ListItemText primary="Utilizadores" />
                </ListItem>
            </Link>
        </>
    )
}
